// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== ZEP MEMORY MODERN UI ===== */

/* Main memory system container with scroll */
.memory-system {
  width: 100%;
  height: calc(100vh - 120px);
  /* Full height minus header/tabs */
  overflow-y: auto;
  /* Enable vertical scrolling */
  overflow-x: hidden;
  /* Hide horizontal scroll */
  padding: 20px;
  margin: 0;
  box-sizing: border-box;
}

/* Custom scrollbar styling */
.memory-system::-webkit-scrollbar {
  width: 8px;
}

.memory-system::-webkit-scrollbar-track {
  background: var(--bg-secondary, #f1f1f1);
  border-radius: 10px;
}

.memory-system::-webkit-scrollbar-thumb {
  background: var(--border-color, #888);
  border-radius: 10px;
}

.memory-system::-webkit-scrollbar-thumb:hover {
  background: var(--text-secondary, #555);
}

.memory-dag-container {
  width: 100%;
  margin: 0;
  padding: 24px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  color: #2d3748;
}

/* ===== HEADER SECTION ===== */
.memory-header {
  text-align: center;
  margin-bottom: 32px;
  padding: 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  color: white;
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
}

.memory-header h2 {
  margin: 0 0 16px 0;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.memory-stats {
  display: flex;
  justify-content: center;
  gap: 32px;
  flex-wrap: wrap;
  margin-top: 20px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.stat-label {
  font-size: 12px;
  opacity: 0.9;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
}

/* ===== ERROR BANNER ===== */
.error-banner {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  color: white;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
  animation: slideIn 0.3s ease-out;
}

.close-error {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.close-error:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* ===== MODERN TABS ===== */
.memory-tabs {
  display: flex;
  background: white;
  border-radius: 12px;
  padding: 6px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  gap: 4px;
}

.tab {
  flex: 1 1;
  padding: 12px 20px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  transition: all 0.2s ease;
  position: relative;
}

.tab:hover {
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
}

.tab.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

/* ===== CONTENT SECTIONS ===== */
.facts-section,
.graph-section,
.interactions-section {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;
}

.facts-section h3,
.graph-section h3,
.interactions-section h3 {
  margin: 0 0 24px 0;
  font-size: 20px;
  font-weight: 700;
  color: #1a202c;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ===== FACT TYPE SECTIONS ===== */
.fact-type-section {
  margin-bottom: 24px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  background: #fafafa;
}

.fact-type-header {
  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
  padding: 16px 20px;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.fact-count {
  background: #667eea;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.facts-list {
  padding: 0;
}

.fact-item {
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: white;
  transition: background 0.2s;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.fact-item:last-child {
  border-bottom: none;
}

.fact-item:hover {
  background: #f8fafc;
}

/* Delete button for individual facts */
.delete-fact-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;
  opacity: 0.4;
  transition: all 0.2s;
  padding: 4px 8px;
  border-radius: 4px;
  flex-shrink: 0;
}

.delete-fact-btn:hover {
  opacity: 1;
  background: rgba(245, 101, 101, 0.15);
}

.fact-item:hover .delete-fact-btn {
  opacity: 0.7;
}

.fact-content {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.fact-importance-indicator {
  width: 8px;
  height: 100%;
  min-height: 40px;
  border-radius: 4px;
  flex-shrink: 0;
}

.fact-text {
  flex: 1 1;
  font-size: 14px;
  line-height: 1.6;
  color: #2d3748;
  margin-bottom: 8px;
}

.fact-meta {
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #64748b;
  margin-top: 8px;
}

.fact-timestamp,
.fact-rating {
  padding: 4px 8px;
  background: #f1f5f9;
  border-radius: 6px;
}

/* ===== GRAPH SECTION ===== */
.graph-stats {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.graph-stat {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(240, 147, 251, 0.3);
}

.graph-visualization {
  margin-top: 20px;
}

.custom-graph-container {
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  min-height: 400px;
  position: relative;
  overflow: hidden;
}

.graph-node {
  position: absolute;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  max-width: 200px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid white;
}

.graph-node:hover {
  transform: scale(1.05);
  z-index: 10;
}

.graph-edge {
  position: absolute;
  height: 2px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  transform-origin: left center;
  opacity: 0.6;
}

.empty-state,
.empty-graph {
  text-align: center;
  padding: 48px 24px;
  color: #64748b;
  background: #f8fafc;
  border-radius: 12px;
  border: 2px dashed #cbd5e0;
}

.empty-state p,
.empty-graph p {
  margin: 8px 0;
  font-size: 16px;
}

.empty-state p:first-child,
.empty-graph p:first-child {
  font-weight: 600;
  color: #4a5568;
}

/* ===== ACTION BUTTONS ===== */
.memory-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 32px;
}

.export-btn,
.clear-btn,
.refresh-btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  overflow: hidden;
}

.export-btn {
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.3);
}

.clear-btn {
  background: linear-gradient(135deg, #f56565 0%, #e53e3e 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(245, 101, 101, 0.3);
}

.refresh-btn {
  background: linear-gradient(135deg, #4299e1 0%, #3182ce 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(66, 153, 225, 0.3);
}

.export-btn:hover,
.clear-btn:hover,
.refresh-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.export-btn:disabled,
.clear-btn:disabled,
.refresh-btn:disabled {
  background: #cbd5e0;
  color: #a0aec0;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* ===== MODAL ===== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.modal {
  background: white;
  border-radius: 16px;
  padding: 32px;
  max-width: 480px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;
}

.modal h3 {
  margin: 0 0 16px 0;
  font-size: 20px;
  font-weight: 700;
  color: #1a202c;
}

.modal p {
  margin: 0 0 24px 0;
  color: #4a5568;
  line-height: 1.6;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.confirm-btn {
  background: linear-gradient(135deg, #f56565 0%, #e53e3e 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-btn {
  background: #edf2f7;
  color: #4a5568;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.confirm-btn:hover {
  transform: translateY(-1px);
}

.cancel-btn:hover {
  background: #e2e8f0;
}

/* ===== INTERACTIONS SECTION ===== */
.interactions-list {
  background: #f8fafc;
  border-radius: 12px;
  padding: 24px;
  border: 2px dashed #cbd5e0;
  text-align: center;
  color: #64748b;
}

.interactions-list p {
  margin: 8px 0;
  line-height: 1.6;
}

/* ===== ANIMATIONS ===== */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* ===== RESPONSIVE DESIGN ===== */
@media (max-width: 768px) {
  .memory-dag-container {
    padding: 16px;
  }

  .memory-header {
    padding: 20px;
  }

  .memory-stats {
    gap: 20px;
  }

  .memory-tabs {
    flex-direction: column;
    gap: 2px;
  }

  .tab {
    text-align: center;
  }

  .facts-section,
  .graph-section,
  .interactions-section {
    padding: 20px;
  }

  .fact-content {
    flex-direction: column;
    gap: 12px;
  }

  .fact-meta {
    flex-direction: column;
    gap: 8px;
  }

  .memory-actions {
    flex-direction: column;
  }

  .modal {
    padding: 24px;
    margin: 16px;
  }

  .modal-actions {
    flex-direction: column;
  }
}

/* ===== LOADING STATES ===== */
.loading {
  opacity: 0.6;
  pointer-events: none;
}

.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #e2e8f0;
  border-radius: 50%;
  border-top-color: #667eea;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ===== DARK THEME SUPPORT ===== */
[data-theme="dark"] .memory-dag-container {
  background: linear-gradient(135deg, #1a202c 0%, #2d3748 100%);
  color: #e2e8f0;
}

[data-theme="dark"] .facts-section,
[data-theme="dark"] .graph-section,
[data-theme="dark"] .interactions-section {
  background: #2d3748;
  border: 1px solid #4a5568;
}

[data-theme="dark"] .memory-tabs {
  background: #2d3748;
  border: 1px solid #4a5568;
}

[data-theme="dark"] .tab {
  color: #a0aec0;
}

[data-theme="dark"] .tab:hover {
  background: rgba(102, 126, 234, 0.2);
  color: #90cdf4;
}

[data-theme="dark"] .fact-item {
  background: #2d3748;
  border-color: #4a5568;
}

[data-theme="dark"] .fact-item:hover {
  background: #374151;
}

[data-theme="dark"] .modal {
  background: #2d3748;
  border: 1px solid #4a5568;
}

/* ===== ACCESSIBILITY ===== */
.tab:focus-visible,
.export-btn:focus-visible,
.clear-btn:focus-visible,
.refresh-btn:focus-visible {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}

.fact-item:focus-within {
  outline: 2px solid #667eea;
  outline-offset: -2px;
}`, "",{"version":3,"sources":["webpack://./src/MemoryDAG.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC,6CAA6C;AAC7C;EACE,WAAW;EACX,2BAA2B;EAC3B,kCAAkC;EAClC,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,SAAS;EACT,aAAa;EACb,iHAAiH;EACjH,6DAA6D;EAC7D,iBAAiB;EACjB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;AACjD;;AAEA,iCAAiC;AACjC;;;EAGE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,eAAe;EACf,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,4DAA4D;EAC5D,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,8CAA8C;AAChD;;AAEA;;;EAGE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,mCAAmC;AACnC;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB","sourcesContent":["/* ===== ZEP MEMORY MODERN UI ===== */\n\n/* Main memory system container with scroll */\n.memory-system {\n  width: 100%;\n  height: calc(100vh - 120px);\n  /* Full height minus header/tabs */\n  overflow-y: auto;\n  /* Enable vertical scrolling */\n  overflow-x: hidden;\n  /* Hide horizontal scroll */\n  padding: 20px;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n/* Custom scrollbar styling */\n.memory-system::-webkit-scrollbar {\n  width: 8px;\n}\n\n.memory-system::-webkit-scrollbar-track {\n  background: var(--bg-secondary, #f1f1f1);\n  border-radius: 10px;\n}\n\n.memory-system::-webkit-scrollbar-thumb {\n  background: var(--border-color, #888);\n  border-radius: 10px;\n}\n\n.memory-system::-webkit-scrollbar-thumb:hover {\n  background: var(--text-secondary, #555);\n}\n\n.memory-dag-container {\n  width: 100%;\n  margin: 0;\n  padding: 24px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  min-height: 100vh;\n  color: #2d3748;\n}\n\n/* ===== HEADER SECTION ===== */\n.memory-header {\n  text-align: center;\n  margin-bottom: 32px;\n  padding: 24px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 16px;\n  color: white;\n  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);\n}\n\n.memory-header h2 {\n  margin: 0 0 16px 0;\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.5px;\n}\n\n.memory-stats {\n  display: flex;\n  justify-content: center;\n  gap: 32px;\n  flex-wrap: wrap;\n  margin-top: 20px;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.stat-label {\n  font-size: 12px;\n  opacity: 0.9;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: #fff;\n}\n\n/* ===== ERROR BANNER ===== */\n.error-banner {\n  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);\n  color: white;\n  padding: 16px 20px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);\n  animation: slideIn 0.3s ease-out;\n}\n\n.close-error {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.close-error:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* ===== MODERN TABS ===== */\n.memory-tabs {\n  display: flex;\n  background: white;\n  border-radius: 12px;\n  padding: 6px;\n  margin-bottom: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  gap: 4px;\n}\n\n.tab {\n  flex: 1;\n  padding: 12px 20px;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  color: #64748b;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.tab:hover {\n  background: rgba(102, 126, 234, 0.1);\n  color: #667eea;\n}\n\n.tab.active {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n/* ===== CONTENT SECTIONS ===== */\n.facts-section,\n.graph-section,\n.interactions-section {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  margin-bottom: 24px;\n}\n\n.facts-section h3,\n.graph-section h3,\n.interactions-section h3 {\n  margin: 0 0 24px 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #1a202c;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ===== FACT TYPE SECTIONS ===== */\n.fact-type-section {\n  margin-bottom: 24px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fafafa;\n}\n\n.fact-type-header {\n  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);\n  padding: 16px 20px;\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #2d3748;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.fact-count {\n  background: #667eea;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.facts-list {\n  padding: 0;\n}\n\n.fact-item {\n  padding: 16px 20px;\n  border-bottom: 1px solid #e2e8f0;\n  background: white;\n  transition: background 0.2s;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.fact-item:last-child {\n  border-bottom: none;\n}\n\n.fact-item:hover {\n  background: #f8fafc;\n}\n\n/* Delete button for individual facts */\n.delete-fact-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  opacity: 0.4;\n  transition: all 0.2s;\n  padding: 4px 8px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n.delete-fact-btn:hover {\n  opacity: 1;\n  background: rgba(245, 101, 101, 0.15);\n}\n\n.fact-item:hover .delete-fact-btn {\n  opacity: 0.7;\n}\n\n.fact-content {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.fact-importance-indicator {\n  width: 8px;\n  height: 100%;\n  min-height: 40px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n.fact-text {\n  flex: 1;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #2d3748;\n  margin-bottom: 8px;\n}\n\n.fact-meta {\n  display: flex;\n  gap: 16px;\n  font-size: 12px;\n  color: #64748b;\n  margin-top: 8px;\n}\n\n.fact-timestamp,\n.fact-rating {\n  padding: 4px 8px;\n  background: #f1f5f9;\n  border-radius: 6px;\n}\n\n/* ===== GRAPH SECTION ===== */\n.graph-stats {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.graph-stat {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n  color: white;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  box-shadow: 0 4px 12px rgba(240, 147, 251, 0.3);\n}\n\n.graph-visualization {\n  margin-top: 20px;\n}\n\n.custom-graph-container {\n  background: #f8fafc;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 24px;\n  min-height: 400px;\n  position: relative;\n  overflow: hidden;\n}\n\n.graph-node {\n  position: absolute;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  max-width: 200px;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 2px solid white;\n}\n\n.graph-node:hover {\n  transform: scale(1.05);\n  z-index: 10;\n}\n\n.graph-edge {\n  position: absolute;\n  height: 2px;\n  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n  transform-origin: left center;\n  opacity: 0.6;\n}\n\n.empty-state,\n.empty-graph {\n  text-align: center;\n  padding: 48px 24px;\n  color: #64748b;\n  background: #f8fafc;\n  border-radius: 12px;\n  border: 2px dashed #cbd5e0;\n}\n\n.empty-state p,\n.empty-graph p {\n  margin: 8px 0;\n  font-size: 16px;\n}\n\n.empty-state p:first-child,\n.empty-graph p:first-child {\n  font-weight: 600;\n  color: #4a5568;\n}\n\n/* ===== ACTION BUTTONS ===== */\n.memory-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-top: 32px;\n}\n\n.export-btn,\n.clear-btn,\n.refresh-btn {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n  overflow: hidden;\n}\n\n.export-btn {\n  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.3);\n}\n\n.clear-btn {\n  background: linear-gradient(135deg, #f56565 0%, #e53e3e 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(245, 101, 101, 0.3);\n}\n\n.refresh-btn {\n  background: linear-gradient(135deg, #4299e1 0%, #3182ce 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(66, 153, 225, 0.3);\n}\n\n.export-btn:hover,\n.clear-btn:hover,\n.refresh-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n}\n\n.export-btn:disabled,\n.clear-btn:disabled,\n.refresh-btn:disabled {\n  background: #cbd5e0;\n  color: #a0aec0;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* ===== MODAL ===== */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n}\n\n.modal {\n  background: white;\n  border-radius: 16px;\n  padding: 32px;\n  max-width: 480px;\n  width: 90%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n.modal h3 {\n  margin: 0 0 16px 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #1a202c;\n}\n\n.modal p {\n  margin: 0 0 24px 0;\n  color: #4a5568;\n  line-height: 1.6;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.confirm-btn {\n  background: linear-gradient(135deg, #f56565 0%, #e53e3e 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.cancel-btn {\n  background: #edf2f7;\n  color: #4a5568;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.confirm-btn:hover {\n  transform: translateY(-1px);\n}\n\n.cancel-btn:hover {\n  background: #e2e8f0;\n}\n\n/* ===== INTERACTIONS SECTION ===== */\n.interactions-list {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 24px;\n  border: 2px dashed #cbd5e0;\n  text-align: center;\n  color: #64748b;\n}\n\n.interactions-list p {\n  margin: 8px 0;\n  line-height: 1.6;\n}\n\n/* ===== ANIMATIONS ===== */\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n/* ===== RESPONSIVE DESIGN ===== */\n@media (max-width: 768px) {\n  .memory-dag-container {\n    padding: 16px;\n  }\n\n  .memory-header {\n    padding: 20px;\n  }\n\n  .memory-stats {\n    gap: 20px;\n  }\n\n  .memory-tabs {\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  .tab {\n    text-align: center;\n  }\n\n  .facts-section,\n  .graph-section,\n  .interactions-section {\n    padding: 20px;\n  }\n\n  .fact-content {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .fact-meta {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .memory-actions {\n    flex-direction: column;\n  }\n\n  .modal {\n    padding: 24px;\n    margin: 16px;\n  }\n\n  .modal-actions {\n    flex-direction: column;\n  }\n}\n\n/* ===== LOADING STATES ===== */\n.loading {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid #e2e8f0;\n  border-radius: 50%;\n  border-top-color: #667eea;\n  animation: spin 1s ease-in-out infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ===== DARK THEME SUPPORT ===== */\n[data-theme=\"dark\"] .memory-dag-container {\n  background: linear-gradient(135deg, #1a202c 0%, #2d3748 100%);\n  color: #e2e8f0;\n}\n\n[data-theme=\"dark\"] .facts-section,\n[data-theme=\"dark\"] .graph-section,\n[data-theme=\"dark\"] .interactions-section {\n  background: #2d3748;\n  border: 1px solid #4a5568;\n}\n\n[data-theme=\"dark\"] .memory-tabs {\n  background: #2d3748;\n  border: 1px solid #4a5568;\n}\n\n[data-theme=\"dark\"] .tab {\n  color: #a0aec0;\n}\n\n[data-theme=\"dark\"] .tab:hover {\n  background: rgba(102, 126, 234, 0.2);\n  color: #90cdf4;\n}\n\n[data-theme=\"dark\"] .fact-item {\n  background: #2d3748;\n  border-color: #4a5568;\n}\n\n[data-theme=\"dark\"] .fact-item:hover {\n  background: #374151;\n}\n\n[data-theme=\"dark\"] .modal {\n  background: #2d3748;\n  border: 1px solid #4a5568;\n}\n\n/* ===== ACCESSIBILITY ===== */\n.tab:focus-visible,\n.export-btn:focus-visible,\n.clear-btn:focus-visible,\n.refresh-btn:focus-visible {\n  outline: 2px solid #667eea;\n  outline-offset: 2px;\n}\n\n.fact-item:focus-within {\n  outline: 2px solid #667eea;\n  outline-offset: -2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
